var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"label text-white m-r-xs none-radius inline",class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.translatedStatus)+" ")]),(_vm.lastStatusDate)?_c('span',{staticClass:"text-muted text-xs"},[_vm._v("("+_vm._s(_vm._f("moment")(_vm.lastStatusDate,"DD/MM/YY HH:mm"))+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }